import FormularioService from '../API/FormularioService';
import { useAppDispatch } from './reduxHooks';

const useFormularioFiles = () => {
  const dispatch = useAppDispatch();

  const uploadFiles = async ({ files, folio, clave }) => {
    if (!files?.length) return Promise.resolve();

    return FormularioService.createFolder({ dispatch, identifier: folio }).then(async () => {
      const allFiles = files?.map(file => {
        const formData = new FormData();
        const nameArray = file.name.split('.');

        formData.append('file', file, `${nameArray[0]}_${new Date().getTime()}.${nameArray[1]}`);
        return FormularioService.uploadFile({ dispatch, identifier: folio, data: formData });
      });
      await Promise.all(allFiles).then(newFiles => {
        const toSaveFileUrls = newFiles.map(fileSaved => fileSaved.strUrl);
        FormularioService.uploadFileUrls({
          dispatch,
          clave,
          folio,
          urls: toSaveFileUrls,
        });
      });
    });
  };

  return {
    uploadFiles,
  };
};

export default useFormularioFiles;
